// removed by extract-text-webpack-plugin
module.exports = {"homeCarousel":"KLNdW_jXjIn0mKBzCa3AQ","coverImage":"jEjNvMb_GBhQkDi0poDuC","dots":"_3gEtNmi6tBloQvemhRgSN-","dot":"_3AgjZvJ0cUhTgmrs93pSyn","solidDot":"_32Fdcu4rq7VQSz_2WG8m7U","projectLink":"_3204X6guLhdbaCvc1Nh6wU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/Carousel.css
// module id = 343
// module chunks = 0